import React, { Component } from 'react';
import PropTypes from 'prop-types';

import BatchRecordTable from "./BatchRecordTable";



const BatchRecords = ({ user, batch, registerRecordList, deRegisterRecordList, onClaimIDClick, onClaimNumberClick,onErrorClick  }) => {
  if ((Object.keys(user).length === 0) || (Object.keys(batch).length === 0)){
    return (<div/>);
  }
  return (
    <div className="box">
      <div>
        Pakki númer {batch.batchID} og sendur af notanda {user.sentByUsername}
      </div>
      <BatchRecordTable list={registerRecordList} recordAction={1} onClaimIDClick={onClaimIDClick} onClaimNumberClick={onClaimNumberClick} onErrorClick={onErrorClick}/>
      <br/>
      <BatchRecordTable list={deRegisterRecordList} recordAction={2} onClaimIDClick={onClaimIDClick} onClaimNumberClick={onClaimNumberClick} onErrorClick={onErrorClick}/>
    </div>
  );
};

BatchRecords.propTypes = {
  user: PropTypes.object,
  batch : PropTypes.object,
  registerRecordList: PropTypes.array,
  deRegisterRecordList: PropTypes.array,
  onClaimIDClick : PropTypes.func,
  onClaimNumberClick : PropTypes.func,
  onErrorClick : PropTypes.func,
};

export default BatchRecords;




// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Batch/BatchRecords.js